import React from "react";
import Map, {
    Markers,
    Polylines,
    Polygons,
    Overlays,
    Marker,
    Controls,
} from "./googlemaps/";
import _ from "lodash";
import { getCurrentPage } from "../helpers";

import POIItem from "./POIItem";
import RouteProfile from './RouteProfile';
import DropDownLinks from "./DropDownLinks";

class MapWrapper extends React.Component {
    handleButtonClick = () => {
        this.props.handleSubmit();
    }

    render() {
        const markers = _.omit(this.props.map.markers, ["geolocation"]);

        // Fit bounds to POI only when no valid locations and not on Leisure Rids
        const valid_locations = _.filter(
            this.props.locations,
            (location) => location.lat && location.lng
        );
        const fitToLocationMarkersOnly =
            valid_locations.length >= 1 ||
            getCurrentPage() === "leisure-rides" ||
            getCurrentPage() === "single-cycle-route";
        const fitBounds = fitToLocationMarkersOnly
            ? { markers: ["routePlanner"], polylines: true }
            : { markers: true, polylines: false };

        return (
            <div className="map-wrapper">
                <DropDownLinks />
                <Map fitBounds={fitBounds} {...this.props}>
                    <Markers markers={markers} {...this.props} />
                    <Polylines polylines={this.props.map.polylines} />
                    <Polygons polygons={this.props.map.polygons} />
                    <Overlays
                        overlays={this.props.map.overlays}
                        {...this.props}
                    />

                    {this.props.map.markers.geolocation && (
                        <Marker
                            markerlocation={
                                this.props.map.markers.geolocation[0].location
                            }
                            icon={this.props.map.markers.geolocation[0].icon}
                        />
                    )}
                    {this.props.map.markers.geolocation && (
                        <Marker
                            markerlocation={
                                this.props.map.markers.geolocation[1].location
                            }
                            icon={this.props.map.markers.geolocation[1].icon}
                        />
                    )}

                    <Controls {...this.props} />

                    {this.props.showbikeParking !== false && (
                        <div className="bike-parking-wrapper">
                            <POIItem
                                poiType={"bikeParking"}
                                label={"Show Bike Parking"}
                                valid_locations={valid_locations}
                                {...this.props}
                            />
                        </div>
                    )}
                </Map>

                <div className="large-content">
                    {getCurrentPage() === "route-planning" && (
                        <RouteProfile {...this.props} />
                    )}
                </div>
            </div>
        );
    }
}

export default MapWrapper;



// WEBPACK FOOTER //
// ./src/components/MapWrapper.js